var map = {
	"./albergolosone.jpg": [
		164,
		0
	],
	"./alpina.jpg": [
		165,
		1
	],
	"./ameronswissmountain.jpg": [
		166,
		12
	],
	"./artdecomontana.jpg": [
		167,
		23
	],
	"./arthotel_riposo.jpg": [
		168,
		34
	],
	"./atlantis.jpg": [
		169,
		45
	],
	"./backstage-vernissage.jpg": [
		170,
		55
	],
	"./badrutt-s-palace.jpg": [
		171,
		56
	],
	"./baur-au-lac.jpg": [
		172,
		57
	],
	"./beatus.jpg": [
		173,
		58
	],
	"./beaurivage.jpg": [
		174,
		2
	],
	"./beaurivagepalace.jpg": [
		175,
		3
	],
	"./bodmi.jpg": [
		176,
		4
	],
	"./buergenstock.jpg": [
		177,
		5
	],
	"./castello_del_sole.jpg": [
		178,
		6
	],
	"./chedi.jpg": [
		179,
		7
	],
	"./de_rougemont.jpg": [
		180,
		8
	],
	"./doldenhorn.jpg": [
		181,
		9
	],
	"./dolder-grand.jpg": [
		182,
		10
	],
	"./eden-roc.jpg": [
		183,
		11
	],
	"./ermitage.jpg": [
		184,
		13
	],
	"./fairmontlemontreux.jpg": [
		185,
		14
	],
	"./fourseasons.jpg": [
		186,
		15
	],
	"./fruttfamilylodge.jpg": [
		187,
		16
	],
	"./giardino.jpg": [
		188,
		17
	],
	"./ginabelle.jpg": [
		189,
		18
	],
	"./grandhotelquellenhof.jpg": [
		190,
		19
	],
	"./gstaad_palace.jpg": [
		191,
		20
	],
	"./hof_weissbad.jpg": [
		192,
		21
	],
	"./huus-gstaad.jpg": [
		193,
		22
	],
	"./kempinski.jpg": [
		194,
		24
	],
	"./kulm.jpg": [
		195,
		25
	],
	"./la-reserve-geneve.jpg": [
		196,
		26
	],
	"./le-grand-bellevue.jpg": [
		197,
		27
	],
	"./lenkerhof.jpg": [
		198,
		28
	],
	"./lestroisrois.jpg": [
		199,
		29
	],
	"./maerchenhotelbraunwald.jpg": [
		200,
		30
	],
	"./mandarinoriental.jpg": [
		201,
		31
	],
	"./nira-alpina.jpg": [
		202,
		32
	],
	"./pirmin_zurbriggen.jpg": [
		203,
		33
	],
	"./placeholder.jpg": [
		204,
		35
	],
	"./priva.jpg": [
		205,
		36
	],
	"./radissonblue.jpg": [
		206,
		37
	],
	"./rockresort.jpg": [
		207,
		38
	],
	"./romantik-hotel-julen-zermatt.jpg": [
		208,
		39
	],
	"./saratzt.jpg": [
		209,
		40
	],
	"./schweizerhof.jpg": [
		210,
		41
	],
	"./schweizerhofbern.jpg": [
		211,
		42
	],
	"./spitzhorn.jpg": [
		212,
		43
	],
	"./suvretta-house.jpg": [
		213,
		44
	],
	"./swiss_holiday_park.jpg": [
		214,
		46
	],
	"./thehide.jpg": [
		215,
		47
	],
	"./tschuggen.jpg": [
		216,
		48
	],
	"./ultima-gstaad.jpg": [
		217,
		49
	],
	"./valbellainn.jpg": [
		218,
		50
	],
	"./victoriajungfrau.jpg": [
		219,
		51
	],
	"./vitznauerhof.jpg": [
		220,
		52
	],
	"./wellnesshotelgolfpanorama.jpg": [
		221,
		53
	],
	"./widder.jpg": [
		222,
		54
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 68;
module.exports = webpackAsyncContext;